const initialState = {
    isModalOpened: false,
    modalId:'',
    cart: null,
    mnhtooltipIsoc: ''
}
function modalWindow(state = initialState, action) {
    switch (action.type) {
        case 'OPEN_MODAL':
            return Object.assign({}, state, {
                isModalOpened: true,
                modalId: action.value
            })
        case 'CLOSE_MODAL':
            return Object.assign({}, state, {
                isModalOpened: false,
                modalId:''
            })
        case 'CART_MODAL_OPEN':
            return { ...state, cart: {
                isModalOpened: true,
                modalId: action.value
            }}
        case 'CART_MODAL_ISOC':
            return Object.assign({}, state, {
                mnhtooltipIsoc: action.value,
            })
        case 'CART_MODAL_CLOSE':
            return { ...state, cart: null }
        default:
            return state
    }

}
export default modalWindow
